import { render, staticRenderFns } from "./checklist-album.vue?vue&type=template&id=7470e9c0&scoped=true"
import script from "./checklist-album.vue?vue&type=script&lang=js"
export * from "./checklist-album.vue?vue&type=script&lang=js"
import style0 from "./checklist-album.vue?vue&type=style&index=0&id=7470e9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470e9c0",
  null
  
)

export default component.exports